@let allUsers = getAllUsers();

<div
    class="avatar-group"
    [class.clickable]="!editable"
    matTooltip="Show all users"
    [matTooltipClass]="'cerrix-tooltip'"
    [matTooltipDisabled]="editable || disableTooltip"
    [attr.data-uiid]="dataUiid + '-avatar-group'"
    (click)="!editable && !disableTooltip && openStaffingPopup()"
>
    @if (!editable && allUsers.length === 0) {
        <span>None</span>
    } @else {
        @for (user of allUsers.slice(0, 3); track $index) {
            <user-avatar
                [user]="user"
                [showShadow]="$index > 0"
                [attr.data-uiid]="dataUiid + '-user-avatar-' + $index"
                [lastUser]="editable && $index === 2"
            ></user-avatar>
        }
        @if (editable) {
            <user-add-avatar
                [class]="getMessageTypes()"
                (click)="openStaffingPopup()"
                matTooltip="Assign users"
                [attr.data-uiid]="dataUiid + '-add-avatar'"
                [matTooltipClass]="'cerrix-tooltip'"
            ></user-add-avatar>
        } @else if (allUsers.length > 3) {
            <div class="more-avatar-group">
                <span>+{{ allUsers.slice(3).length }}</span>
            </div>
        }
    }
</div>
@if (editable && hasMessages()) {
    <span class="error-message">Assign more users</span>
}
